/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { IconButton } from '@coursera/cds-core';
import { ArrowUpIcon } from '@coursera/cds-icons';

import type { CustomSendButtonProps } from 'bundles/ai-coach-platform/components/patterns/chat/types';

import _t from 'i18n!nls/xdp';

const styles = {
  sendButton: css`
    margin-right: var(--cds-spacing-100);

    // Quadrupled ampersand beats ChatInputField's (0,3,2) svg path { fill }
    // rule on the suffix slot without resorting to !important.
    &&&& svg path {
      fill: var(--cds-color-neutral-primary-invert);
    }

    // Tripled ampersand wins specificity tie with ChatInputField's inset rule,
    //apply outset focus ring styles for primary buttons (platform uses ghost).
    &&&.cds-buttonBase-focusVisible::after {
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
    }
  `,
};

const TwoPanelChatSendButton = ({ onClick, disabled }: CustomSendButtonProps) => {
  const sendMessageLabel = _t('Send message');
  return (
    <IconButton
      variant="primary"
      icon={<ArrowUpIcon />}
      aria-label={sendMessageLabel}
      tooltip={sendMessageLabel}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
      size="small"
      css={styles.sendButton}
      data-testid="coach-send-button"
    />
  );
};

export default TwoPanelChatSendButton;
